import React from 'react';
import { useAuth } from '../../../providers/auth';
import Loader from '../../../components/Loader';
import RecoverForm from '../../../components/forms/RecoverForm';
import { AuthLayout } from '../../../components/layouts/AuthLayout';

export function RecoverPass() {
  const { loading } = useAuth();

  if (loading) {
    return <Loader fullScreen />;
  }

  return (
    <AuthLayout
      title="Recuperar senha"
      description="Informe o email da sua conta. Enviaremos um link para redefinir a senha."
    >
      <RecoverForm />
    </AuthLayout>
  );
}
